import { fetchDispatch } from 'data/helpers'
import { showSnackbar, snackbarTypes } from 'src/redux/snackbar'
import { fetchTrackEvent, ProductAnalyticsEventTypes } from 'src/redux/productAnalytics'

export const CREATE_HOUSING_INTEREST_LOADING = 'housingInterest/CREATE_HOUSING_INTEREST_LOADING'
export const CREATE_HOUSING_INTEREST_SUCCESS = 'housingInterest/CREATE_HOUSING_INTEREST_SUCCESS'
export const CREATE_HOUSING_INTEREST_FAILURE = 'housingInterest/CREATE_HOUSING_INTEREST_FAILURE'

export const FETCH_ALL_HOUSING_INTERESTS_LOADING = 'housingInterest/FETCH_ALL_HOUSING_INTERESTS_LOADING'
export const FETCH_ALL_HOUSING_INTERESTS_SUCCESS = 'housingInterest/FETCH_ALL_HOUSING_INTERESTS_SUCCESS'
export const FETCH_ALL_HOUSING_INTERESTS_FAILURE = 'housingInterest/FETCH_ALL_HOUSING_INTERESTS_FAILURE'

export const createHousingInterestLoading = () => ({ type: CREATE_HOUSING_INTEREST_LOADING })
export const createHousingInterestSuccess = () => ({ type: CREATE_HOUSING_INTEREST_SUCCESS })
export const createHousingInterestFailure = payload => ({
  type: CREATE_HOUSING_INTEREST_FAILURE,
  payload,
})

export const fetchAllHousingInterestsLoading = () => ({ type: FETCH_ALL_HOUSING_INTERESTS_LOADING })
export const fetchAllHousingInterestsSuccess = payload => ({
  type: FETCH_ALL_HOUSING_INTERESTS_SUCCESS,
  payload,
})
export const fetchAllHousingInterestsFailure = payload => ({
  type: FETCH_ALL_HOUSING_INTERESTS_FAILURE,
  payload,
})

export const fetchCreateHousingInterest = query => {
  return async dispatch => {
    dispatch(createHousingInterestLoading())
    try {
      await fetchDispatch({
        path: '/api/housing_interest',
        values: query,
        method: 'POST',
      })
      dispatch(createHousingInterestSuccess())
      dispatch(showSnackbar('Submitted contact form!', snackbarTypes.SUCCESS))
      dispatch(
        fetchTrackEvent({
          eventName: 'housing_interest_submitted',
          eventType: ProductAnalyticsEventTypes.ACTION,
          userId: query.email,
        }),
      )
    } catch (error) {
      dispatch(createHousingInterestFailure(error.response))
    }
  }
}

export const fetchAllHousingInterests = () => {
  return async dispatch => {
    dispatch(fetchAllHousingInterestsLoading())
    try {
      const response = await fetchDispatch({
        path: '/api/housing_interest',
        method: 'GET',
      })
      dispatch(fetchAllHousingInterestsSuccess(response))
    } catch (error) {
      dispatch(fetchAllHousingInterestsFailure(error))
    }
  }
}

const initialState = {
  loading: false,
  interestedUsers: [],
}

export const housingInterestReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_HOUSING_INTEREST_LOADING:
      return {
        ...state,
        loading: true,
      }
    case CREATE_HOUSING_INTEREST_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case CREATE_HOUSING_INTEREST_FAILURE:
      return {
        ...state,
        loading: false,
      }
    case FETCH_ALL_HOUSING_INTERESTS_LOADING:
      return {
        ...state,
        loading: true,
      }
    case FETCH_ALL_HOUSING_INTERESTS_SUCCESS:
      return {
        ...state,
        loading: false,
        interestedUsers: action.payload.housingInterests,
      }
    case FETCH_ALL_HOUSING_INTERESTS_FAILURE:
      return {
        ...state,
        loading: false,
      }
    default:
      return state
  }
}
